<template>
  <span class="px-3 text-uppercase text-secondary text-xxs font-weight-bolder">
    {{ props.text }}
  </span>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    default: null,
  },
});
</script>

<style lang="scss" scoped>
.rightAlign{
  color:blue;
  text-align: end;
}
.leftAlign{
  color:blue;
  text-align: start;
}
// :deep(.col_alignLeft) {
//   text-align: left;
// }
// :deep(.col_alignRight) {
//   text-align: right !important;
//   color: red;
// }
// .hd_alignLeft{
//   text-transform: capitalize;   
//   font-weight: bold;
//   text-align: right;
// }
// .hd_alignCenter{
//   text-transform: capitalize;   
//   font-weight: bold;
//   text-align: center;
// }
</style>
